import { render, staticRenderFns } from "./SiteOptionsMenu.vue?vue&type=template&id=168612a9&scoped=true"
import script from "./SiteOptionsMenu.vue?vue&type=script&lang=js"
export * from "./SiteOptionsMenu.vue?vue&type=script&lang=js"
import style0 from "./SiteOptionsMenu.vue?vue&type=style&index=0&id=168612a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168612a9",
  null
  
)

export default component.exports